import React, { useState } from 'react';
import { v4 } from 'uuid';
import { Spinner } from 'react-magma-dom';
import { CloudDownloadIcon } from 'react-magma-icons';
import { ErrorDownloadModal } from '../Modal/ErrorDownloadModal';
import { StyledLeftSideLinks, StyledShortRelated, StyledTitle, StyledType } from '../Styled/StyledRelatedNav';
import { StyledShortRelatedDownload } from '../Styled';
import { StyledButtonSpinnerWrapper } from '../Styled/StyledWrappers';
import { handleDownloadFile } from '../../utils';
import { COLORS } from '../../constants';

interface IRelated {
  title: string;
  type: string;
  fileLink: string;
  defaultColor: string;
  gradient: string;
}

export const ShortRelatedItem = (props: IRelated): JSX.Element => {
  const { title, type, fileLink, defaultColor, gradient } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const openErrorModal = () => {
    setIsErrorModalOpen(true);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const handleDownload = () => {
    !isLoading && handleDownloadFile(title, fileLink, setIsLoading, openErrorModal);
  };

  const onControlKey = (event: React.KeyboardEvent) => {
    const { key } = event;

    if (key == 'Enter') {
      return handleDownload();
    }
  };

  return (
    <>
      <StyledShortRelated
        key={v4()}
        tabIndex={0}
        data-testid="short-related-item"
        gradient={gradient}
        defaultColor={defaultColor}
        onClick={() => {
          if (type !== 'Video') handleDownload();
        }}
        disabled={isLoading}
        onKeyDown={event => onControlKey(event)}
        aria-label={`Download ${type} ${title}`}
      >
        <StyledLeftSideLinks>
          {isLoading ? (
            <StyledButtonSpinnerWrapper className="file-download-loader" margin="0 0 0 10px">
              <Spinner color={defaultColor} size={36} />
            </StyledButtonSpinnerWrapper>
          ) : (
            <StyledShortRelatedDownload className="short-related-download">
              <CloudDownloadIcon />
            </StyledShortRelatedDownload>
          )}
          <StyledTitle className="short-related-title">{title}</StyledTitle>
        </StyledLeftSideLinks>
        <StyledType>{type}</StyledType>
      </StyledShortRelated>
      {isErrorModalOpen && (
        <ErrorDownloadModal
          mainColor={defaultColor || COLORS.seaBlue}
          onCloseClick={closeErrorModal}
          onRetryClick={() => {
            closeErrorModal();
            handleDownload();
          }}
        />
      )}
    </>
  );
};
